import { z } from 'zod';
import { zDbId } from '~/plugins/zod/utils';

export const ConfigDataInfoSchema = z.object({
    AppVersion: z.string(),
    AvailableLocales: z.string().array(),
    Password: z.object({
        MinLength: z.number(),
        MixedCase: z.boolean(),
        Numbers: z.boolean(),
        Symbols: z.boolean(),
    }),
    RootFolderId: zDbId(),
    UploadMaxFilesize: z.number(),
});

export type ConfigDataInfo = z.infer<typeof ConfigDataInfoSchema>;
